import { ARCADE_HEX } from '../config/theme';

/**
 * Post-it em pixel: borda preta de uma unidade `u`, miolo colorido e a
 * dobra com degrau no canto inferior direito (Figma, "Icon / post-it").
 */
export function desenharPostIt (g, x, y, w, h, { cor, dobra, u = 7 }) {
    const p = (px, py) => ({ x: x + px, y: y + py });

    // Contorno com o canto inferior direito recortado em dois degraus.
    g.fillStyle(ARCADE_HEX.TINTA, 1).fillPoints([
        p(0, 0), p(w, 0), p(w, h - 2 * u), p(w - u, h - 2 * u), p(w - u, h - u),
        p(w - 2 * u, h - u), p(w - 2 * u, h), p(0, h)
    ], true);

    g.fillStyle(cor, 1).fillRect(x + u, y + u, w - 2 * u, h - 2 * u);

    // Bloco 5×5 do canto: moldura preta, dobra 3×3 e o degrau preto.
    const cx = x + w - 5 * u, cy = y + h - 5 * u;
    g.fillStyle(ARCADE_HEX.TINTA, 1).fillRect(cx, cy, 4 * u, 4 * u);
    g.fillStyle(dobra, 1).fillRect(cx + u, cy + u, 3 * u, 2 * u).fillRect(cx + u, cy + 3 * u, 2 * u, u);
}
